
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
export default {
    components: {
        vcLoading           : () => import('../../../components/pages/loading.vue'),
        breadcrumbs         : () => import('../../../components/pages/breadcrumbs.vue'),
        contentCollection   : () => import('../../../components/product/collection-content.vue')
    },
    data() {
        return {
            access_catalog  : true,
            current_date    : moment().format('YYYY-MM-DD'),
            disabled_button : false
        };
    },
    async mounted(){
		this.$root.$on('change-access-catalog'      , this.changeAccessCatalog);
    },
    computed: {
        ...mapGetters({
			getterTranslates 	            : 'getterTranslates',
			getterStoreLang	 	            : 'getterStoreLang',
            getterDownloadTransactionsFile  : 'getterDownloadTransactionsFile',
            getterDownloadPriceCatalog      : 'getterDownloadPriceCatalog'
        })
    },
    methods:{
        ...mapActions({
            downloadPriceCatalog: 'downloadPriceCatalog',
            deletePriceCatalog  : 'deletePriceCatalog'
        }),
        changeAccessCatalog(access) {
            this.access_catalog = access;
        },
        downloadExportFile( data_file ) {
            
            if( ![null, ''].includes( data_file ) ){
                
                document.getElementById('download_file').href = `${ this.$config.hefesto_file.baseURL }${ data_file }`;
                document.getElementById('download_file').download = `${ this.$config.hefesto_file.baseURL }${ data_file }`.substring( `${ this.$config.hefesto_file.baseURL }${ data_file }`.lastIndexOf('/') + 1 );
                document.getElementById('download_file').click();
                setTimeout(async () => {
                    
                    await this.deletePriceCatalog({ url_file: data_file });
                }, 3000);
            }
        },
        async createExportTable(){
            this.disabled_button = true;
            await this.downloadPriceCatalog().then( (result_file) => {
                
                this.disabled_button = false;
                this.downloadExportFile( this.getterDownloadPriceCatalog );
            });
        },
    }
}
